import React from 'react'
import * as S from './styled'
import { IconArrowRight } from '../iconArrowRight'

const CardLink = ({ title, description = '', url = '', hover = true }) => {
  return (
    <S.LinkCardTo to={url}>
      <S.ContainerCardLink className='cnt-cardlink' hoverEffect={hover}>
        <S.ContentCardLink className='textContentCardLink'>
          <S.TitleCardLink>{title}</S.TitleCardLink>
          <S.DescriptionCardLink>{description}</S.DescriptionCardLink>
        </S.ContentCardLink>
        <S.IconContentCardLink className='iconContentCardLink'>
          <IconArrowRight />
        </S.IconContentCardLink>
      </S.ContainerCardLink>
    </S.LinkCardTo>
  )
}

export default CardLink
